<template>
  <form
    autocomplete="off"
    class="flex items-center gap-2"
    @submit.prevent="handleSearch"
  >
    <SearchQueryTextInput
      v-model="searchParams.search"
      placeholder="Find a Project"
      class="*:!mb-0 *:h-[43px]"
    />

    <template v-if="planStore.selectedFramework">
      <div class="min-w-96 w-auto">
        <FrameworkCategorySelect
          :framework="planStore.selectedFramework"
          :show-header="false"
          placeholder="Filter by Category"
          :model-value="getCategoryModelValue()"
          @update:model-value="searchParams.category = $event?.length ? $event[0].id : null"
        />
      </div>
    </template>

    <button
      type="button"
      class="text-secondary hover:text-secondary-light hover:cursor-pointer"
      @click="handleReset"
    >
      <i class="fa-solid fa-circle-xmark" />
      <span class="pl-1.5">Clear search</span>
    </button>
  </form>
</template>

<script setup>
import { ref, watch } from 'vue';

import { SearchFormWrapper } from '@/components/forms';
import { SearchQueryTextInput, FrameworkCategorySelect } from '@/components/form-inputs';

import { usePlanStore } from '@/store';

const emit = defineEmits(['search', 'reset']);
defineProps({
  categories: {
    type: Array,
    default: () => [],
  },
});

const planStore = usePlanStore();

const searchParams = ref({
  search: null,
  category: null,
});

const handleReset = () => {
  searchParams.value = {};

  handleSearch();
};

const handleSearch = () => {
  emit('search', JSON.parse(JSON.stringify(searchParams.value)));
};

// Get the category object by its ID. This is needed to be able to set the model value for the framework category select to `null` when the search is cleared
const getCategoryModelValue = () => {
  if (!planStore.selectedFramework) {
    return null;
  }

  // Get the category object from its ID
  return planStore.selectedFramework.categories.find(category => category.id === searchParams.value.category) || null;
};

watch(searchParams, () => {
  handleSearch();
}, { deep: true });
</script>
